import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenSquare } from '@fortawesome/free-solid-svg-icons';

import './RosterGridItem.scss';
import { ReactComponent as Caret} from '../../images/ico-drawer.svg';
import { RosterGridItemProps } from './models/RosterGridItem.interfaces';
import { useSelector } from 'react-redux';
import { selectControls } from '../../redux/controls';

export const RosterGridItem = ({children, isExpanded, onDelete, onEdit, onExpand, roster}: RosterGridItemProps): JSX.Element => {
  const controls = useSelector(selectControls);

  return (
    <>
      <li className="nqt-roster-modal--list-item">
        <button
          className="nqt-roster-modal--list-item__caret"
          role='button'
          aria-expanded={isExpanded}
          aria-controls={`${roster.rosterID}-child-controls`}
          aria-label={`Toggle Roster Name ${roster.rosterName} Student List`}
          onClick={() => onExpand()}>
          <Caret className='caret' width={20} height={20} style={{ transform: !isExpanded ? 'rotate(90deg)' : 'rotate(180deg)' }}/>
        </button>
        <button className="nqt-roster-modal--list-item__edit"
          onClick={() => onEdit()} aria-label={controls?.RosterItemEditText?.controlText}>
          <FontAwesomeIcon className='fa-square-pen' icon={faPenSquare} ></FontAwesomeIcon>
        </button>
        <button className="nqt-roster-modal--list-item__button nqt-roster-modal--link"
          onClick={() => onDelete()}>
          {
            controls?.RosterDelete?.controlText
          }
        </button>
        <span className="nqt-roster-modal--list-item__label">{roster.rosterName}</span>
      </li>
      {
        (children && isExpanded) &&
        <section className="nqt-roster-grid-item--children">
          <div className="nqt-roster-grid-item--children-container">
            <header>
              <h3 className="nqt-roster-grid-item--student-list__header">Student List</h3>
            </header>
            <ul id={`${roster.rosterID}-child-controls`} className="nqt-roster-grid-item--student-list">
              {
                children
              }
            </ul>
          </div>
        </section>
      }
    </>
  );
};

export default RosterGridItem;